// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"201":"c00cb336","359":"efd4f1a0","401":"31947b96","475":"10dd4e95","807":"1f27a308","923":"cc1b123f"}[chunkId] + ".css";
};